import React, { createRef, useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_GROUPS, API_CLIENTS } from '../utils/constants';
import ButtonLoad from './ButtonLoad';
import { useSelector } from 'react-redux';
const md5 = require('md5');

const NewClientModal = (props) => {
  const { userInfo } = useSelector((state) => state.auth);

  const timeZones = [
    { id: 1, name: 'Eastern Daylight Time - (GMT-4)' },
    { id: 2, name: 'Central Daylight Time - (GMT-5)' },
    { id: 3, name: 'Mountain Daylight Time - (GMT-6)' },
    { id: 4, name: 'Mountain Standard Time - (GMT-7)' },
    { id: 5, name: 'Pacific Daylight Time - (GMT-7)' },
    { id: 6, name: 'Alaska Daylight Time - (GMT-8)' },
    { id: 7, name: 'Hawaii-Aleutian Standard Time - (GMT-10)' }
  ];
  const [optionsData, setOptionsData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientGroups, setClientGroups] = useState('');
  const [savingClient, setSavingClient] = useState(false);
  const [clientTimeZone, setClientTimeZone] = useState('');
  const [modalDismiss, setModalDismiss] = useState(createRef());

  useEffect(() => {
    axios
      .get(API_GROUPS, {
        headers: {
          Authorization: `bearer ${userInfo.accessToken}`
        }
      })
      .then((response) => {
        // If request is good..S.
        const groupsData = response.data.groups;
        setOptionsData(groupsData);
        setLoaded(true);
      })
      .catch((error) => {
        console.error('error ' + error);
      });
  }, [userInfo.accessToken]);

  const handleSelectChanges = (option) => {
    let options = '';
    if (option !== null) {
      options = option.map((option) => {
        return { id: option.value, groupName: option.label };
      });
    }
    setClientGroups(options);
  };

  const handleSelectTimeZone = (option) => {
    setClientTimeZone(option.label);
  };

  const newClientSave = () => {
    const newClientUrl = API_CLIENTS;

    setSavingClient(true);
    if (clientName.length === 0 || clientTimeZone.length === 0) {
      Swal.fire({
        title: 'Error!',
        text: 'Incomplete Values.'
      }).then((r) => {
        setClientName('');
        setSavingClient(false);
      });
      return;
    }

    let newClientName = clientName.replace(/\s+/g, ' ');
    newClientName = newClientName.replace(/^\s+|\s+$/g, '');
    newClientName = newClientName.replace(/’/g, "'");

    const clientDataSaved = {
      id: md5(clientName),
      clientName: newClientName,
      clientGroups: clientGroups,
      clientTimeZone: clientTimeZone
    };

    axios({
      method: 'post',
      url: newClientUrl,
      data: {
        clientName: newClientName,
        clientGroups: clientGroups,
        timeZone: clientTimeZone
      }
    })
      .then(function (response) {
        if (response.status === 200) {
          Swal.fire({
            type: 'success',
            title: 'Success!',
            text: 'The client was created successfully.'
          }).then(() => {
            setSavingClient(false);
            someFn(clientDataSaved);
            modalDismiss.click();

            // Activate AI generation after the alert for new customers
            setTimeout(() => {
              if (props.onClientCreated) {
                props.onClientCreated(clientDataSaved);
              }
            }, 500);
          });
        }
      })
      .catch(function (xhr, ajaxOptions, thrownError) {
        Swal.fire({
          type: 'error',
          title: 'Error!',
          text: 'The client was not created successfully due an error.'
        }).then(() => {
          setSavingClient(false);
          modalDismiss.click();
        });
      });
  };

  const handleClientChange = (e) => {
    setClientName(e.target.value);
  };

  const someFn = (listInfo) => {
    props.callbackFromParent(listInfo);
  };

  // Handle close via onOpenChange
  const handleClose = () => {
    if (props.onOpenChange) {
      props.onOpenChange(false);
    }
  };

  if (!loaded) {
    return (
      <div className="spinner-grow" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  // Only render if open prop is true (controlled mode)
  if (props.open === false) {
    return null;
  }

  return (
    <>
      {/* Modal backdrop */}
      <div
        className="modal-backdrop fade show"
        onClick={handleClose}
        style={{ zIndex: 1040, display: 'block' }}
      />
      <div
        className="modal fade show"
        id="addNewClient"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="addNewClientLabel"
        aria-modal="true"
        style={{ display: 'block', zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content tx-14">
            <div className="modal-header">
              <h6 className="modal-title" id="addNewClientLabel">
                Add New Client
              </h6>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label htmlFor="formGroupExampleInput" className="block">
                    What's the client name?
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Client Name"
                    value={clientName}
                    onChange={handleClientChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="formGroupExampleInput" className="block">
                    What's the client group?
                  </label>
                  <Select
                    options={optionsData.map((option, idx) => ({
                      value: option.id,
                      label: option.groupName
                    }))}
                    isMulti
                    onChange={handleSelectChanges}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="formGroupExampleInput" className="block">
                    Select Time Zone:
                  </label>
                  <Select
                    className="basic-single"
                    options={timeZones.map((zone) => ({
                      value: zone.id,
                      label: zone.name
                    }))}
                    onChange={handleSelectTimeZone}
                  />
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary tx-13"
                onClick={handleClose}>
                Close
              </button>
              <ButtonLoad
                state={savingClient}
                btn={'btn-primary'}
                icon={'fa-plus'}
                text={'Save Client'}
                callback={() => {
                  newClientSave();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewClientModal;
